import { Input } from '@iwoca/orion';
import { Controller, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import type { LinkBankAccountFormValues } from './LinkBankAccount.types';
import {
    normalizeBankAccountNumber,
    normalizeSortCode
} from '../../../../helpers/normalizers';

export const LinkUKBankAccount = () => {
    const {
        control,
        formState: { errors }
    } = useFormContext<LinkBankAccountFormValues>();

    return (
        <div
            className="sm:flex-row sm:justify-between mb-xl flex flex-col gap-l"
            data-testid="link-bank-account-modal"
        >
            <div className="sm:w-[45%] w-full">
                <Controller
                    control={control}
                    name="accountNumber"
                    render={({
                        field: { onChange, value, onBlur, name, ref }
                    }) => (
                        /* eslint-disable-next-line iwoca/input-a11y */
                        <Input
                            ref={ref}
                            name={name}
                            label={
                                <FormattedMessage
                                    id="_.modal.link_bank_account.account_number"
                                    defaultMessage="Account number"
                                />
                            }
                            data-testid="account-number-input"
                            className="fs-exclude"
                            value={value ?? ''}
                            onBlur={onBlur}
                            onChange={(e) =>
                                onChange(
                                    normalizeBankAccountNumber(e.target.value)
                                )
                            }
                            error={errors.accountNumber?.message}
                        />
                    )}
                />
            </div>
            <div className="sm:w-[45%] w-full">
                <Controller
                    control={control}
                    name="sortCode"
                    render={({
                        field: { onChange, value, onBlur, name, ref }
                    }) => (
                        /* eslint-disable-next-line iwoca/input-a11y */
                        <Input
                            ref={ref}
                            name={name}
                            label={
                                <FormattedMessage
                                    id="_.modal.link_bank_account.sort_code"
                                    defaultMessage="Sort code"
                                />
                            }
                            data-testid="sortcode-input"
                            className="fs-exclude"
                            value={value ?? ''}
                            onBlur={onBlur}
                            onChange={(e) =>
                                onChange(normalizeSortCode(e.target.value))
                            }
                            error={errors.sortCode?.message}
                        />
                    )}
                />
            </div>
        </div>
    );
};
